import { Home, LayoutGrid, Package, ShoppingCart, Tag } from "lucide-react";
import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const HomePage = lazyPage(() => import("./pages/HomePage"), "HomePage");
const BrandsPage = lazyPage(() => import("./pages/BrandsPage"), "BrandsPage");
const CategoriesPage = lazyPage(() => import("./pages/CategoriesPage"), "CategoriesPage");
const ShopPage = lazyPage(() => import("./pages/ShopPage"), "ShopPage");
const SearchPage = lazyPage(() => import("./pages/SearchPage"), "SearchPage");
const VisualSearchResultsPage = lazyPage(
  () => import("./pages/VisualSearchResultsPage"),
  "VisualSearchResultsPage",
);
const ProductDetailPage = lazyPage(() => import("./pages/ProductDetailPage"), "ProductDetailPage");
const WishlistPage = lazyPage(() => import("./pages/WishlistPage"), "WishlistPage");

export const catalogModule: WebModule = {
  id: "catalog",
  nav: [
    { id: "home", title: "Home", url: "/", icon: Home },
    { id: "categories", title: "Categories", url: "/categories", icon: LayoutGrid },
    { id: "cart", title: "Cart", url: "/cart", icon: ShoppingCart },
    { id: "brands", title: "Brands", url: "/brands", icon: Tag },
    { id: "orders", title: "Orders", url: "/orders", icon: Package },
  ],
  routes: [{ path: "/wishlist", element: <WishlistPage /> }],
  publicRoutes: [
    { path: "/", element: <HomePage /> },
    { path: "/brands", element: <BrandsPage /> },
    { path: "/categories", element: <CategoriesPage /> },
    { path: "/shop", element: <ShopPage /> },
    { path: "/search", element: <SearchPage /> },
    { path: "/search/visual", element: <VisualSearchResultsPage /> },
    { path: "/catalog/:id", element: <ProductDetailPage /> },
  ],
};
